import React from "react";
import * as FlagIcons from "country-flag-icons/react/3x2";
import { FaMapMarkerAlt } from "react-icons/fa";
import { isIso3166Alpha2 } from "./hubwayzCountryFlag";
import { hubwayzDestinationOptionParts } from "./hubwayzDestinationOptions";

/**
 * Hotels-tab suggestion row: flag, name, country, type, in RTL.
 * The flag SVG is bundled. No flag image request is made.
 */
export default function HubwayzDestinationOptionLine({ dest }) {
  const { name, country, typeLabel } = hubwayzDestinationOptionParts(dest);
  const code = String(dest?.countryCode || "").trim().toUpperCase();
  const Flag = isIso3166Alpha2(code) ? FlagIcons[code] : null;
  return (
    <div className="hubwayz-destination-line" dir="rtl">
      {Flag ? (
        <Flag className="hubwayz-destination-flag" aria-hidden="true" />
      ) : (
        <FaMapMarkerAlt className="hubwayz-destination-pin" aria-hidden="true" />
      )}
      {name ? <span className="hubwayz-destination-name">{name}</span> : null}
      {country ? <span className="hubwayz-destination-country">{country}</span> : null}
      {typeLabel ? <span className="hubwayz-destination-type">{typeLabel}</span> : null}
    </div>
  );
}
